import { combineReducers, createStore } from "redux";
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import responseContext from "./handleResponseContext/ResponseContext";
import processingModal from "./handleProcessingModal/ProcessingModal";
import AlertModal from "./handleAlertModal/AlertModal";
import cameraFrontGuide from "./handleCameraFrontGuideModal/CameraFrontGuideModal";
import configPageReducer from './handleConfigReducer/ConfigPage';

const reducer = combineReducers <any>(
    {
        responseContextReducer: responseContext,
        processingModalReducer: processingModal,
        alertModalReducer: AlertModal,
        cameraFrontGuideReducer: cameraFrontGuide,
        configPageReducer: configPageReducer,
    }
);

const persistConfig: any = {
  key: 'root', // کلید برای ذخیره سازی در storage
  storage, // نوع storage که می خواهید استفاده کنید (localStorage، sessionStorage و غیره)
  whitelist: ['configPageReducer'], // ریدوسرهایی که می خواهید persist شوند (اختیاری)
  blacklist: ['responseContextReducer', 'processingModalReducer', 'alertModalReducer', 'cameraFrontGuideReducer'], // ریدوسرهایی که نمی خواهید persist شوند (اختیاری)
};

const persistedReducer: any = persistReducer(persistConfig, reducer);

export const store = createStore(persistedReducer);
export const persistor = persistStore(store);
